// Generated with tools/create-component.js
import React, { useEffect } from "react";
import { Button, Image, Link } from "components";
import { HeroHomepageQueryFragment } from "codegen";
import "./HeroHomepage.scss";
import AOS from "aos";
import "aos/dist/aos.css";
import classNames from "classnames";
import { decode } from "html-entities";

interface HeroHomepageProps {
  data: HeroHomepageQueryFragment;
}

export const HeroHomepage: React.FC<HeroHomepageProps> = ({ data: { image, titleLineOne, titleLineTwo, button } }) => {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <section
      className={classNames({
        "hero-homepage": true,
        "layout--large": true,
        "hero--colour": !image,
        initClassNames: true,
      })}
    >
      <div className="hero__wrapper">
        <div className="hero__wrapper--content">
          <h1 dangerouslySetInnerHTML={{ __html: titleLineOne }} data-aos="fade-right" />
          {button && (
            <div data-aos="fade-right">
              <Link to={button.url} target={button.target} title={decode(button.title)} className="button--primary">
                <Button variant="outline" colorScheme="secondary" rightIcon="ArrowLink">
                  {decode(button.title)}
                </Button>
              </Link>
            </div>
          )}
          {image && <Image src={image} className="hero__background" />}
        </div>
        <span className="hero__wrapper--cta" data-aos="fade-down">
          Scroll Down
        </span>
      </div>
    </section>
  );
};
